const GraphSkeletonLoader = () => {
  return (
    <div className="mx-auto w-full max-w-6xl animate-pulse p-4">
      {/* Legend */}
      <div className="mb-6 flex justify-center gap-6">
        <div className="flex items-center gap-2">
          <div className="size-3 rounded-full bg-gray-400" />
          <div className="h-4 w-14 rounded bg-gray-300" />
        </div>
        <div className="flex items-center gap-2">
          <div className="size-3 rounded-full bg-gray-400" />
          <div className="h-4 w-14 rounded bg-gray-300" />
        </div>
      </div>
      {/* Bar Chart Skeleton */}
      <div className="relative flex h-64 items-end justify-between gap-4 border-b border-l border-gray-300 pb-4 pl-4">
        {Array.from({ length: 12 }).map((_, index) => {
          const barHeight = Math.floor(Math.random() * 120) + 40;
          return (
            <div key={index} className="flex w-14 flex-col items-center">
              <div
                className="w-full rounded bg-gray-300"
                style={{ height: `${barHeight}px` }}
              />
              <div className="mt-1 text-xs text-gray-400">•</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GraphSkeletonLoader;
